import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import alterarExibicaoDetalhamentoRota from '../../actions/rota/alterarExibicaoDetalhamentoRota';
import selecionarConexao from '../../actions/rota/selecionarConexao';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarRota from '../../actions/rota/selecionarRota';
import iconCidade from '../../img/cidade.png';

export class Conexao extends React.Component {
  selecionarConexao () {
    this.props.selecionarOrigem(this.props.conexao.cidadeOrigem);
    this.props.selecionarDestino(this.props.conexao.cidadeDestino);
    this.props.selecionarConexao(this.props.conexao);
    this.props.selecionarRota(this.props.rota)

    if (this.props.conexao.cidadesConexao) {      
      this.props.preencherCidades(this.props.conexao.cidadesConexao);
    }
  }

  render () {
    return (
          <div className="row">
            <div className="col-lg-1 col-xl-1">
            </div>
            <div className="col-lg-1 col-xl-1">
              <span className="titulo-mobile">ID:&nbsp;</span>{this.props.conexao.id}
            </div>
            <div className="col-lg-1 col-xl-1">
              <span className="titulo-mobile">Prefixo:&nbsp;</span>{this.props.conexao.prefixo ? this.props.conexao.prefixo : 'Não informado'}
            </div>
            <div className="col-lg-3 col-xl-3">
              <span className="titulo-mobile">Cidade origem:&nbsp;</span>{this.props.conexao.cidadeOrigem.nome}
            </div>

            <div className="col-lg-3 col-xl-3">
              <span className="titulo-mobile">Cidade destino:&nbsp;</span>{this.props.conexao.cidadeDestino.nome}
            </div>

            <div className="col-lg-3 col-xl-3">
              <Autorizacao
                perfisPermitidos={[PERFIL_ADMIN,
                    getAdminEmpresa(this.props.empresaSelecionada.id),
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                  getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <div className="acoes">
                  <div className="botoes">
                    <button type="button" className="btn btn-excluir"
                            data-toggle="modal"
                            data-target="#modalConfirmacaoExclusaoConexao"
                            title='Excluir'
                            onClick={() => this.props.selecionarConexao(this.props.conexao)}>
                      <i className="material-icons nav-icon">&#xe872;</i>
                    </button>
                    <button type="button" className="btn btn-editar ml-2"
                            data-toggle="modal"
                            title='Editar'
                            data-target="#modalCadastroConexao"
                            onClick={() => this.selecionarConexao(this.props.conexao)}>
                      <i className="material-icons nav-icon">&#xe150;</i>
                    </button>
                    <button type="button" className="btn btn-editar ml-2"
                            data-toggle="modal"
                            title='Adicionar Cidades Origem'
                            data-target="#modalAdicionarCidades"
                            onClick={() => this.selecionarConexao(this.props.conexao)}>
                      <img src={iconCidade} width={18} height={18} alt="Adicionar Cidades Origem" />
                    </button>
                  </div>
                </div>
              </Autorizacao>
            </div>
        </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    empresaSelecionada: state.empresaSelecionada
  });

export default connect(mapStateToProps, {
  changeFieldValue,
  alterarExibicaoDetalhamentoRota,
  selecionarConexao,
  selecionarOrigem,
  selecionarDestino,
  selecionarRota
})(Conexao)
